"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var styled_components_1 = require("styled-components");

var getPadding = function getPadding(p) {
  return p.gutter ? p.gutter : p.theme.grid.gutter;
};

exports.Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    max-width: ", ";\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "], ["\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    max-width: ", ";\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "])), p.fluid ? '100%' : (p.maxWidth || p.theme.grid.maxWidth) + "px", getPadding(p), getPadding(p));
});
var templateObject_1, templateObject_2;